import appConfig from "appConfig";

import { useState, useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from 'authConfig';
import { callMsGraph } from 'hooks/callMsGraph'; // Your MS Graph helper function

const { restrictedGroupId, fullAccessGroupId } = appConfig;

const useFetchRightsGroups = () => {
  const { instance, accounts, inProgress } = useMsal();
  const [hasFullAccess, setHasFullAccess] = useState(false);
  const [isRestricted, setIsRestricted] = useState(false);
  const [loadingRights, setLoadingRights] = useState(true);

  useEffect(() => {
    const fetchRights = async () => {
      try {
        const response = await instance.acquireTokenSilent({
          ...loginRequest,
          account: accounts[0],
        });
        const accessToken = response.accessToken;

        // Fetch user's group membership from Microsoft Graph
        const groupMembership = await callMsGraph(
          accessToken,
          `${appConfig.microsoftGraphBaseUrl}/me/memberOf?$select=id`
        );
        // Check if the user is part of the restricted group or the full-access group
        const userGroups = groupMembership.value.map(group => group.id);
        const hasFullAccessUser = userGroups.includes(fullAccessGroupId);
        const isInRestrictedGroup = userGroups.includes(restrictedGroupId);

        setHasFullAccess(hasFullAccessUser);
        setIsRestricted(isInRestrictedGroup);
      } catch (error) {
        console.error('Error fetching group membership:', error);
      } finally {
        setLoadingRights(false);
      }
    };

    if (inProgress === 'none' && accounts.length > 0) {
      fetchRights();
    } else if (inProgress === 'none') {
      setLoadingRights(false);
    }
  }, [instance, accounts, inProgress]);

  return { hasFullAccess, loadingRights, isRestricted };
};

export default useFetchRightsGroups;
